import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import EcgLoader from 'legacy/containers/EcgLoader'

import { Field, FieldArray, reduxForm, change, unregisterField, isDirty, isPristine } from 'redux-form'
import { withStyles } from '@material-ui/core/styles'

import { green } from '@material-ui/core/colors'
import styles from './TkAndCrpForms.css'
import TextInput from './components/CrpTextInput'
import MaskedInput from './components/CrpMaskedInput'
import CheckboxInput from './components/CheckboxInput'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import Checkbox from '@material-ui/core/Checkbox'

import SelectField from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Link from '@material-ui/core/Link'
import PhoneIcon from '@material-ui/icons/Phone'

import EmailIcon from '@material-ui/icons/Email'

import VisibilityIcon from '@material-ui/icons/Visibility'

import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'

import Loading from '../../components/Loading'
import RadioButtonAvailability from './components/RadioButtonAvailability'
import { AVAILABILITY } from './constants'

import {
  emailMask,
  requiredValidation,
  emailValidation,
  minLen1Validation,
  phoneValidationWith1Prefix,
  isValidNPI,
  castStringBooleanToBoolean,
} from './components/formValidations'
import { checkTKFeatureEnabled } from '../../../configs'
import pluseIcon from 'static/images/Vector.png'
import Typography from '@material-ui/core/Typography'

import FormSection from '../../../views/components/Common/FormSection/FormSection'

import { Box, Button } from '@material-ui/core'

import PassIcon from 'static/images/icons/checkbox-marked-circle-outline.svg'
import CheckedIcon from 'static/images/icons/checkboxCheckedSquare.svg'
import UncheckedIcon from 'static/images/icons/checkboxUncheckedSquare.svg'
import CheckedDisabledIcon from 'static/images/icons/checkboxCheckedDisableSquare.svg'
import RadioButtonInput from './components/RadioButtonInput'

import LicenseEditableTable from '../Tables/LicenseEditableTable'

import CustomModal from '../../../views/components/Modal/CustomModal'

import WarningIcon from '../../../static/images/Warning.png'

import history from '../../containers/History'

import NewUpdatePasswordForm from './NewUpdatePasswordForm'

import { fetchLicenseTableInfo } from '../../../views/state/MyInfoSettings/MyInfoSettingsActions'
import { LICENSE_COVERED_AREAS, LICENSE_COVERED_COUNTRIES, LICENSE_COVERED_EU_REGION_COUNTRIES, getRegion } from 'legacy/constants'
import { FormattedMessage } from 'react-intl'

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />)

const TkandCrpUpdatePasswordForm = props => {
  const dispatch = useDispatch()
  const notificationData = useSelector(state => state.app.dataSources.memberNotificationSettings)
  const memberData = useSelector(state => state.app.dataSources.memberNotificationSettings)
  const [ userType, setUserType ] = useState(1)
  const [ userTypeInited, setUserTypeInited ] = useState(false)
  const [ appointmentNotification, setAppointmentNotification ] = useState({
    isEmail: (tkEnabled || crpEnabled) && notificationData && notificationData.data && notificationData.data.result ? notificationData.data.result.emailEnabled : false,
    isText: (tkEnabled || crpEnabled) && notificationData && notificationData.data && notificationData.data.result ? notificationData.data.result.smsEnabled : false,
  })
  const [ service, setService ] = useState({
    isClinicianReview: crpEnabled && false,
    isTeleKardia: tkEnabled && false,
  })
  const [ openModal, setOpenModal ] = useState(false)
  const [ openUnsaveChangesModal, setOpenUnsaveChangesModal ] = useState(false)
  const [ formFocus, setFormFocus ] = useState(false)
  const [ notificationChange, setNotificationChange ] = useState({
    isEmail: true,
    isText: true,
  })

  const {
    handleSubmit,
    handleInputChange,
    handleNotificationChange,
    validationTests,
    invalid,
    pristine,
    dirty,
    isSubmitting,
    submitting,
    showTKFeatureEnabled: tkEnabled,
    showCRPFeatureEnabled: crpEnabled,
    showRPMFeatureEnabled: rpmEnabled,
    pwError,
    pwErrorMsg,
    me,
    getAppointmentNotificationsSettings,
    onInfoSubmit,
    getMemberInfo,
    memberOnChangeInfo,
    getMe,
    isModalOpen,
    handleModalClosed,
    handleModalOpen,
    handleSavedChanges,
    handleUnsavedChanges,
    handleLeaveWithoutSave,
    initialValues,
    isUnsaved,
  } = props

  const isUsRegion = getRegion() === 'us'
  const coveredRegions = isUsRegion ? LICENSE_COVERED_COUNTRIES : LICENSE_COVERED_EU_REGION_COUNTRIES

  useEffect(() => {
    if (tkEnabled || crpEnabled) {
      getAppointmentNotificationsSettings()
      getMemberInfo() // For getting member's data on my info page
    }
    if (!isAdmin()) dispatch(fetchLicenseTableInfo())
  }, [ crpEnabled, dispatch, getAppointmentNotificationsSettings, getMemberInfo, isAdmin, tkEnabled ])

  useEffect(() => {
    if ((tkEnabled || crpEnabled) && notificationData && notificationData.data && notificationData.data.result) {
      setAppointmentNotification({
        isEmail: notificationData.data.result.emailEnabled,
        isText: notificationData.data.result.smsEnabled,
      })
    }
  }, [ crpEnabled, notificationData, tkEnabled ])

  useEffect(() => {
    if (!((notificationChange.isEmail && (notificationChange.isText)) && pristine)) {
      handleUnsavedChanges()
    } else {
      handleSavedChanges()
    }
  }, [ handleSavedChanges, handleUnsavedChanges, notificationChange, pristine ])

  useEffect(() => {
    const { permissions } = ((me || {}).data || {}).profile || {}
    let type = userType
    if (!userTypeInited && permissions) {
      if (permissions.isPhysician) {
        type += 2
      }
      if (permissions.isAdmin) {
        type += 3
      }
      setUserTypeInited(true)
      setUserType(type)
    }
  }, [ me, userTypeInited, userType ])
  // Member info section implementation on My Info page
  const renderSelectField = withStyles({
    select: {
      height: '10px',
      background: '#FFFFFF',
    },
  })(({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
  }) => (
    <FormControl size="small" variant="outlined" fullWidth>
      <InputLabel className={styles.label} style={{ marginBottom: '4px' }}>{label}</InputLabel>
      <SelectField
        floatingLabelText={label}
        errorText={touched && error}
        className={styles.selectFieldStyle}
        {...input}
        // eslint-disable-next-line react/no-children-prop
        children={children}
        {...custom}
      />
      {error && <span className={styles.error}>{error}</span>}
    </FormControl>
  ))

  const isAdmin = () => userType === 4
  const isPhysician = () => userType === 3
  const isAdminPhysician = () => userType === 6
  const updateUserType = (e, newValue, previousValue, name) => {
    const fieldName = name.split('.')[1]
    let newType = userType
    switch (fieldName) {
    case 'isPhysician':
      newType += (newValue ? 2 : -2)
      break
    case 'isAdmin':
      newType += (newValue ? 3 : -3)
      break
    default:
      break
    }
    // 1 = neither
    // 3 = physician
    // 4 = admin
    // 6 = physician and admin
    setUserType(newType)
  }
  const hideModalNetwork = () => setOpenModal(false)
  const hideModalUnsaveChanges = () => setOpenUnsaveChangesModal(false)
  const retryHandler = e => {
    setOpenModal(false)
    setTimeout(() => { submitDetails(e) }, 300)
  }
  // function to submit details and check network issue
  const submitDetails = ev => {
    ev.preventDefault()
    if (window.navigator.onLine) {
      handleNotificationChange(appointmentNotification)
      onInfoSubmit(memberOnChangeInfo)
    } else {
      setOpenModal(true)
    }
  }

  return (
    <form onSubmit={submitDetails} className={styles.updatePasswordForm}>
      {
        <React.Fragment>
          {(tkEnabled || crpEnabled) && (
            <React.Fragment>
              <FormSection heading={<FormattedMessage id="heading.Member_Roles" />} style={{ padding: '2rem 3rem' }}>
                <div className={styles.formSectionRow}>
                  <div className={styles.checkboxWithDesc}>
                    <Field
                      component={CheckboxInput}
                      labelClassName={styles.memberRole}
                      label={<FormattedMessage id="label.provider" />}
                      name="permissions.isPhysician"
                      description={<FormattedMessage id="description.provider" />}
                      onChange={updateUserType}
                      disabled={!isAdmin() || !isAdminPhysician()}
                      checkedIcon={<CheckedIcon className={styles.checkboxIcon}/>}
                      uncheckedIcon={<UncheckedIcon className={styles.checkboxIcon} />}
                      checkedDisabledIcon={<CheckedDisabledIcon className={styles.disabledCheckboxIcon} />}
                      uncheckedDisabledIcon={<UncheckedIcon className={styles.disabledCheckboxIcon} />}
                    />
                  </div>
                  <div className={styles.checkboxWithDesc}>
                    <Field
                      component={CheckboxInput}
                      labelClassName={styles.memberRole}
                      label={<FormattedMessage id="label.Account_Administrator" />}
                      name="permissions.isAdmin"
                      description={<FormattedMessage id="description.account_adminster" />}
                      onChange={updateUserType}
                      disabled={true}
                      checkedIcon={<CheckedIcon className={styles.checkboxIcon}/>}
                      uncheckedIcon={<UncheckedIcon className={styles.checkboxIcon} />}
                      checkedDisabledIcon={<CheckedDisabledIcon className={styles.disabledCheckboxIcon} />}
                      uncheckedDisabledIcon={<UncheckedIcon className={styles.disabledCheckboxIcon} />}
                    />
                  </div>
                </div>
              </FormSection>
              <FormSection heading={<FormattedMessage id="heading.Member_Information" />} required>
                <div className={styles.formSectionRow}>
                  <div className={styles.editLabelGroup}>
                    <Field
                      component={TextInput}
                      label={<FormattedMessage id="label.first_name" />}
                      name="firstName"
                      placeholder="Enter First Name"
                      required
                      validate={[ minLen1Validation, requiredValidation ]}
                    />
                  </div>
                  <div className={styles.editLabelGroup}>
                    <Field
                      component={TextInput}
                      label={<FormattedMessage id="label.last_name" />}
                      name="lastName"
                      placeholder="Enter Last Name"
                      required
                      validate={[ minLen1Validation, requiredValidation ]}
                    />
                  </div>
                  {(isPhysician() || isAdminPhysician()) && (tkEnabled || crpEnabled) && (
                    <div className={styles.editLabelGroup}>
                      <Field
                        component={TextInput}
                        label={<FormattedMessage id="label.NPI" />}
                        name="npiNo"
                        placeholder="Enter NPI (If Applicable)"
                        validate={[ isValidNPI ]}
                      />
                    </div>
                  )}
                  <div className={styles.editLabelGroup}>
                    <Field
                      component={TextInput}
                      label={<FormattedMessage id="label.phone" />}
                      name="phone"
                      placeholder="Enter phone no"
                      required
                      validate={
                        isUsRegion
                          ? [ requiredValidation, phoneValidationWith1Prefix ]
                          : [ requiredValidation ]
                      }
                      icon={<PhoneIcon />}
                    />
                  </div>
                </div>
                <div
                  className={
                    isUsRegion
                      ? `${styles.formSectionRow}`
                      : `${styles.formSectionRow} ${styles.contentJustify}`
                  }
                >
                  <div className={styles.editLabelGroup}>
                    <Field
                      component={TextInput}
                      mask={emailMask}
                      placeholder="name@example.com"
                      label={<FormattedMessage id="label.email" />}
                      name="email"
                      required
                      icon={<EmailIcon />}
                      validate={[
                        emailValidation,
                        minLen1Validation,
                        requiredValidation,
                      ]}
                    />
                  </div>
                  <div className={styles.editLabelGroup}>
                    <InputLabel
                      className={styles.label}
                      style={{ marginBottom: '4px' }}
                    >
                      {isUsRegion ? <FormattedMessage id="label.Country" /> : <FormattedMessage id="label.Region" />}
                    </InputLabel>
                    <Field name="country" component={renderSelectField}>
                      {coveredRegions.map((item, i) => (
                        <MenuItem key={i} value={item.code}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Field>
                  </div>
                  {isUsRegion && (
                    <div className={styles.editLabelGroup}>
                      <InputLabel className={styles.label} style={{ marginBottom: '4px' }}><FormattedMessage id="label.State_or_region" /></InputLabel>
                      <Field name="region" component={renderSelectField}>
                        {LICENSE_COVERED_AREAS.map((item, i) => <MenuItem key={i} value={item.code}>{item.name}</MenuItem>)}
                      </Field>
                    </div>
                  )}
                </div>
              </FormSection>
              {(isPhysician() || isAdminPhysician()) &&
                <React.Fragment>
                  {isAdminPhysician() && (
                    <FormSection heading={<FormattedMessage id="heading.Manage_Availability" />} style={{ padding: '2rem 3rem' }}>
                      <div className={styles.formSectionRow}>
                        <div className={styles.checkboxWithDesc}>
                          <Field
                            component={RadioButtonAvailability}
                            name="canManageAvailability"
                            options={AVAILABILITY}
                            props={{ value: AVAILABILITY }}
                            normalize={castStringBooleanToBoolean}
                          />
                        </div>
                      </div>
                    </FormSection>
                  )}
                  <FormSection heading={<FormattedMessage id="heading.License_Information" />}>
                    <div style={{ flexDirection: 'column' }} className={styles.formSectionRow}>
                      <LicenseEditableTable viewOnly={true} me={me} />
                    </div>
                  </FormSection>
                </React.Fragment>
              }
              {/* Start Appointment Notifications  */}
              <FormSection heading={<FormattedMessage id="heading.Notifications" />}>
                <div style={{ justifyContent: 'unset' }} className={styles.formSectionRow}>
                  {notificationData && notificationData.isFetching ? (
                    <Loading />
                  ) : (
                    <Box flex flexDirection="colum">
                      <Typography variant="body1" className={styles.appointmentText}>
                        <FormattedMessage id="information.appointment_text" />
                      </Typography>
                      <Box style={{ display: 'flex' }}>
                        <div className={styles.checkboxWithDesc} style={{ marginRight: '4rem' }}>
                          <FormControlLabel
                            control={
                              <GreenCheckbox
                                checked={appointmentNotification.isText}
                                onChange={e => {
                                  setAppointmentNotification({ ...appointmentNotification, isText: e.target.checked })
                                  setNotificationChange({ ...notificationChange, isText: !notificationChange.isText })
                                }}
                                name="isText"
                              />
                            }
                            label={<FormattedMessage id="label.Text" />}
                          />
                        </div>
                        <div className={styles.checkboxWithDesc}>
                          <FormControlLabel
                            control={
                              <GreenCheckbox
                                checked={appointmentNotification.isEmail}
                                onChange={e => {
                                  setAppointmentNotification({ ...appointmentNotification, isEmail: e.target.checked })
                                  setNotificationChange({ ...notificationChange, isEmail: !notificationChange.isEmail })
                                }}
                                name="isEmail"
                              />
                            }
                            label={<FormattedMessage id="label.email" />}
                          />
                        </div>
                        <div className={styles.placeholder} />
                      </Box>
                    </Box>
                  )}
                </div>
              </FormSection>
              <div className={styles.appointmentbuttonWrapper} style={{ justifyContent: 'flex-end' }}>
                {me.isFetching ? (
                  <button disabled className={styles.submitLoading}>
                    <Loading />
                  </button>
                ) : (
                  <button
                    style={{ width: 'auto' }}
                    type="submit"
                    className={styles.submit}
                    disabled={(notificationChange.isEmail && notificationChange.isText) && pristine}
                  >
                    <FormattedMessage id="button.save_changes" />
                  </button>
                )}
              </div>
            </React.Fragment>
          )}

          <CustomModal
            modalType="confirm"
            open={openModal}
            closeModalHandler={hideModalNetwork}
            icon={WarningIcon}
            iconAltText="Warning Icon"
            heading={<FormattedMessage id="alert.network_issue" />}
            descriptionLine1={<FormattedMessage id="description.network_issue_line1" />}
            descriptionLine2={<FormattedMessage id="description.network_issue_line2" />}
            confirmHandler={retryHandler}
            confirmButtonText={<FormattedMessage id="button.try_again" />}
            declineButtonText={<FormattedMessage id="button.cancel" />}
          />
          <CustomModal
            modalType="confirm"
            open={isModalOpen}
            closeModalHandler={handleModalClosed}
            icon={WarningIcon}
            iconAltText="Warning Icon"
            heading={<FormattedMessage id="confirmation.leave_page" />}
            descriptionLine1={<FormattedMessage id="description.leave_page" />}
            descriptionLine2=""
            confirmHandler={handleLeaveWithoutSave}
            confirmButtonText={<FormattedMessage id="button.leave" />}
            declineButtonText={<FormattedMessage id="button.cancel" />}
          />
        </React.Fragment>
      }
    </form>
  )
}

export default reduxForm({
  form: 'tkAndCrpUpdatePasswordForm',
  enableReinitialize: true,
})(TkandCrpUpdatePasswordForm)



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/TkandCrpUpdatePasswordForm.jsx